/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:22:27
 * @Description: 守卫入口
 */
import { loginStateGuard } from "./login-state";
// import { keepAliveGuard } from './keep-alive'

// import { updateTitleGuard } from './title'

/**
 * 注册前置守卫
 * @param {VueRouter} router
 */
export function registerBeforeGuard(router) {
	// 守卫队列
	const guardQueue = [loginStateGuard];
	guardQueue.forEach((guard) => router.beforeEach(guard));
}

/**
 * 注册后置守卫
 * @param {VueRouter} router
 */
export function registerAfterGuard(router) {
	// 守卫队列
	// const guardQueue = [updateTitleGuard]
	// guardQueue.forEach(guard => router.afterEach(guard))
}
